import {makeStyles} from '@mui/styles';
import {Theme} from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    appMain: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      backgroundColor: theme.palette.background.default,
      paddingTop: 56,
      [theme.breakpoints.up('sm')]: {
        paddingTop: 70,
      },
      '&.appMainFixedFooter': {
        '& $mainContainer': {
          paddingBottom: 0,
        },
      },
    },
    mainContent: {
      flex: 1,
      display: 'flex',
      transition: 'all 0.5s ease',
      border: '0 none',
      width: '100vw',
    },
    mainContainer: {
      paddingBottom: 0,
      margin: 0,
      width: '100%',
      '& > .scrollbar-container': {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: 0,
      }
    },

    boxedLayout: {
      [theme.breakpoints.up('lg')]: {
        maxWidth: 1260,
        marginLeft: 'auto',
        marginRight: 'auto',
        '& .fixed-footer': {
          position: 'sticky',
          width: '100%',
        },
        '& $mainContent': {
          width: '100%',
          flex: 'auto',
        },
        '& $mainContainer': {
          width: '100%',
        },
        '& .app-bar': {
          position: 'absolute',
          boxShadow: '0px 0px 4px 2px rgba(0,0,0,0.12)',
          width: '100%',
        },
        '& .grid-btn': {
          fontSize: 11,
        },
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: 1680,
        '& $mainContent': {
          width: '100%',
        },
        '& .app-bar': {
          width: '100%',
        },
      },
    },
  };
});
export default useStyles;
